import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionDummyRoomCapacity } from "./capacity";
import { QuestionDummyRoomKidsPolicy } from "./kids-policy";
import { QuestionDummyRoomMaxRoomNum } from "./max-room-num";

import type { DummyRoomCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	priceAndStockAndPolicy: DummyRoomCategoriesAndManagerStore["priceAndStockAndPolicy"];
};

export const QuestionDummyRoomPriceAndStockAndPolicy = ({ priceAndStockAndPolicy }: Props) => {
	return (
		<>
			<FeatureIslandMainWithCategoryWrapper islandTitle="定員" categoryStore={priceAndStockAndPolicy}>
				<QuestionDummyRoomCapacity />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="在庫" categoryStore={priceAndStockAndPolicy}>
				<QuestionDummyRoomMaxRoomNum />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="キッズポリシー" categoryStore={priceAndStockAndPolicy}>
				<QuestionDummyRoomKidsPolicy />
			</FeatureIslandMainWithCategoryWrapper>
		</>
	);
};

QuestionDummyRoomPriceAndStockAndPolicy.displayName = "QuestionDummyRoomPriceAndStockAndPolicy";
